import React, { useEffect, useState, } from "react";
import { getData, postData } from "../../store/utils";
import './OrderProduct.css'
import { Button } from "bootstrap";
import Modal from "react-modal";
import { FaPlusCircle, FaRegTimesCircle, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { FaCalendarAlt } from 'react-icons/fa';


const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "none",
    padding: "0px",
    width: "90%",
  },
};

const customStylesDisbursement = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "none",
    padding: "0px",
    minWidth: "25%",
    padding: 20,
    maxHeight: '80vh',
    overflowY: 'auto',
    padding: '20px'
  },
};

const closeButtonStyle = {
  position: 'absolute',
  top: '-5px',
  right: '-5px',
  zIndex: 1010,
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
};


const WarehouseOrderDetail = () => {

  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const location = useLocation();
  const { user } = location.state || {}; // Ensure it defaults to an empty object if state is not found

  const orderIdfetch = useParams();
  // const orderIdnew = useParams();
  const orderId = orderIdfetch?.id

  const [orderDetail, setOrderDetailData] = useState({});
  const [userData, setUserData] = useState({});

  console.log("orderDetail2332", userData)

  useEffect(() => {
    const savedUser = sessionStorage.getItem("orderUser");
    if (savedUser) {
      setUserData(JSON.parse(savedUser));
    } else {
      console.error("No user data passed through state or sessionStorage.");
    }
  }, []);

  // new state
  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [orderQuotationOpen, setOrderQuotationOpen] = React.useState(false);

  const [modalPreview, setModalPreview] = useState(false);

  const [shipmentFiles, setShipmentFiles] = useState('');
  const [lrcopyFiles, setLrcopyFiles] = useState('');
  const [receipt, setReceiptFiles] = useState('');

  const [markDelivered, setMarkDelivered] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false)
  const [uploadLoading, setUplaodLoading] = useState(false)



  const [showLoading, setShowLoading] = useState(false);

  async function fetchProductList() {
    setIsLoading(true);
    try {
      const tempData = await getData(
        `lender/getOrderDetailByOrderId?orderId=${orderId}`
      );
      setProductList(tempData?.data || []);

      setOrderDetailData(tempData?.data[0])
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      setIsLoading(false);
    }
  }





  useEffect(() => {
    fetchProductList();
  }, []);

  const [selectedOrderIds, setSelectedOrderIds] = useState([]);

  const toggleSelect = (id) => {
    console.log(id, 'select id');
    setSelectedOrderIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((orderId) => orderId !== id) // Remove if already selected
        : [...prevSelected, id] // Add if not selected
    );
  };

  const filteredItems = productList.filter((item) => {
    console.log(item.orderId, 'item id')
    return (

      selectedOrderIds.includes(item.orderDetailId)
    )
  }



  );



  const onOrderReady = () => {
    if (selectedOrderIds.length > 0) {
      console.log('selected order ids', selectedOrderIds);
      console.log('selected order list', filteredItems);
      setOrderQuotationOpen(true);

    } else {
      Swal.fire({
        icon: 'warning',
        title: 'warning!',
        text: 'atleast one order should be selected',
      });
      // alert('Please select at least one order to proceed.');
      // Perform submit action with selectedOrderIds
    }
  }

  const closeModal = () => {
    // setIsOpen(false);
    setOrderQuotationOpen(false);
    setModalPreview(false);
    // setCheckedItems({
    //   loanApplicationForm: false,
    //   agreement: false,
    //   kfs: false,
    //   osv: false,
    //   cam: false,
    // });
  };





  const handleLrFileChange = (e) => {
    const selectedFiles = Array.from(e?.target?.files);
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    const invalidFiles = selectedFiles.filter((file) => !allowedTypes.includes(file?.type));
    if (invalidFiles?.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Please select valid file formats (.pdf, .jpg, .jpeg, .png)',
      });
      e.target.value = '';
      return;
    }

    const promises = selectedFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader?.result.split(',')[1]);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });


    Promise.all(promises)
      .then((base64Files) => {

        setLrcopyFiles(base64Files[0]);

      })
      .catch((error) => {
        console.error('Error reading file:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'An error occurred while reading the file',
        });
      });
  };

  const handleShipmentFileChange = (e) => {
    const selectedFiles = Array.from(e?.target?.files);
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

    const invalidFiles = selectedFiles.filter((file) => !allowedTypes.includes(file?.type));
    if (invalidFiles?.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Please select valid file formats (.pdf, .jpg, .jpeg, .png)',
      });
      e.target.value = '';
      return;
    }

    const promises = selectedFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader?.result.split(',')[1]);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });


    Promise.all(promises)
      .then((base64Files) => {
        // setCheckFiles((prevFiles) => [...prevFiles, ...base64Files.map((base64) => ({ inputId, base64 })),]);
        setShipmentFiles(base64Files[0]);
      })
      .catch((error) => {
        console.error('Error reading file:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'An error occurred while reading the file',
        });
      });
  };

  const handleRecieptFileChange = (e, inputId) => {

    const selectedFiles = Array.from(e?.target?.files);
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    const invalidFiles = selectedFiles.filter((file) => !allowedTypes.includes(file?.type));
    if (invalidFiles?.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Please select valid file formats (.pdf, .jpg, .jpeg, .png)',
      });
      e.target.value = '';
      return;
    }

    const promises = selectedFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader?.result.split(',')[1]);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(promises)
      .then((base64Files) => {
        setReceiptFiles(base64Files[0]);
      })
      .catch((error) => {
        console.error('Error reading file:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'An error occurred while reading the file',
        });
      });
  };





  const onConfirmOrder = async () => {

    // if(orderDetail.currentShipmentStatus == 40){
    //   setModalPreview(true);
    // }
    const productData = {
      "orderDetailIds": selectedOrderIds,
      "orderId": orderId,
      // "shipmentStatus": orderDetail.currentShipmentStatus == "Shipment Pending" ? 40 : orderDetail.currentShipmentStatus == "In-transit" ? 40 : "",
      "shipmentStatus": 40,
      "userId": orderDetail?.userId
    }

    try {
      setStatusLoading(true);
      const tempData = await postData("delivery/updateDeliveryShipmentStatus", productData);


      if (tempData.statusCode === 200) {
        setStatusLoading(false);
        setOrderQuotationOpen(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);

      } else {
        setStatusLoading(false);
        return null;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }

  }


  const onDeliveredHandler = async () => {
    const productData = {
      "orderDetailIds": selectedOrderIds,
      "orderId": orderId,
      // "shipmentStatus": orderDetail.currentShipmentStatus == "Shipment Pending" ? 40 : orderDetail.currentShipmentStatus == "In-transit" ? 40 : "",
      "shipmentStatus": 41,
      "userId": orderDetail?.userId
    }

    try {
      setShowLoading(true);
      const tempData = await postData("delivery/updateDeliveryShipmentStatus", productData);


      if (tempData.statusCode === 200) {

        history.push("/WarehouseOrderList");
        setShowLoading(false);
        setOrderQuotationOpen(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);

      } else {
        showLoading(false);
        return null;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }

  }

  const onTransitOrder = async () => {
    setModalPreview(true);
    // setOrderQuotationOpen(true);
  }



  const onSubmitDocument = async () => {

    if (!lrcopyFiles && !shipmentFiles && !receipt) {     
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Please upload at least one required documents',
      });
      return;
    }
    const productData = {

      "orderId": orderId,
      "userId": orderDetail?.userId,
      "LRFile": lrcopyFiles,
      "shipmentPhoto": shipmentFiles,
      "receipt": receipt,
      "status": markDelivered ? 41 : 40,

    }
    console.log('product data', productData);
    setUplaodLoading(true)
    try {
      const tempData = await postData("delivery/uploadDoc", productData);


      if (tempData.statusCode === 200) {
        setShowLoading(false);
        setOrderQuotationOpen(false);
        setModalPreview(false);
        setUplaodLoading(false)
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Documents submitted successfully',
        });
        history.push("/WarehouseOrderList");

      } else {
        setShowLoading(false);
        setUplaodLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Something went wrong',
        });
        return null;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setShowLoading(false);
      setUplaodLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Something went wrong',
      });
      return null;
    }


  }




  return (
    <div style={{ marginTop: "20px" }} className="container-fluid">
      <div className="warehouseCardsec">

        {/*  */}
        <div>
          <div className="row noMarginSection mb-3">

            <div className="col-md-12">
              <div className="brd">
                <div className="row mt-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <div><b>Order Id :</b>	{orderId}</div>
                    <div ><b><FaCalendarAlt /> </b>	{orderDetail && orderDetail?.orderDate}</div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-4">
                      <div>	</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div>+91	{orderDetail && orderDetail?.mobileNumber} |
                      &nbsp;

                      {orderDetail && (
                        <span
                          className={
                            orderDetail?.statusName == "Approved"
                              ? "text-success"
                              : orderDetail?.statusName == "Processing"
                                ? "text-warning"
                                : "text-danger"
                          }
                        >
                          {orderDetail && orderDetail?.statusName}
                        </span>
                      )}{" "}
                    </div>
                  </div>

                </div>

                <div className="row mt-2">
                  <div className="col-md-4">
                    <div><b>FOS :</b>	{orderDetail && orderDetail?.fosName ? orderDetail?.fosName : "Not Available"}</div>
                  </div>
                  <div className="col-md-8 mt-2">
                    <div><b>Add :</b>	{orderDetail &&
                      orderDetail?.shopAddress}
                    </div>
                  </div>

                  <div className="col-md-8 mt-2">
                    <div><b>Status :</b>	{orderDetail &&
                      orderDetail?.currentShipmentStatus}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*  */}


        <table style={{ width: "100%" }} className="d-none d-md-block table table-bordered table-striped table-hover table-responsive-sm">
          <thead>
            <tr>
              <th>Select</th>
              <th>Item Name</th>
              <th>Brand</th>
              <th>Quantity</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            {productList.map((item) => (
              <tr key={item.id} style={{ textAlign: "center" }}>
                <td data-label="Select">
                  <input
                    type="checkbox"
                    checked={item.selected}
                    onChange={() => toggleSelect(item.orderDetailId)}
                  />
                </td>
                <td data-label="Item Name">{item.item}</td>
                <td data-label="Brand">{item.brand}</td>
                <td data-label="Quantity">{item.quantity}</td>
                <td data-label="Category">{item.category}</td>
              </tr>
            ))}
          </tbody>
        </table>



        {/* mobile view */}
        <div className="row mt-3">
          <div className="col-sm-12">
            <ul className="cardlisting">
              {
                productList.map((item, index) => {


                  return (
                    <li>
                      <div>
                        <div className="d-flex justify-content-between">


                        </div>

                        <div className="mt-2 d-flex justify-content-between align-items-center">

                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`pick-${item.orderDetailId}`}
                              checked={item.deliveryStatus}
                              onChange={() => toggleSelect(item.orderDetailId)}
                              disabled={orderDetail?.currentShipmentStatus == "Shipment Pending" || orderDetail?.currentShipmentStatus == "Ready for pickup" ? false : true}
                            />
                            <label className="form-check-label" htmlFor={`pick-${item.orderDetailId}`}>

                              <div><b>{item?.item}</b> ({item?.brand})</div>

                            </label>
                          </div>
                          <div>{`Qty - ${item?.quantity}`}</div>

                        </div>
                      </div>
                    </li>
                  )
                })
              }

            </ul>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", margin: "10px auto", width: "300px", padding: "10px 20px" }} className="row noMarginSection mb-3 detailsbtn">

          {(orderDetail?.currentShipmentStatus == "Ready for Pickup" || orderDetail?.currentShipmentStatus == "Shipment Pending") && (
            <button disabled={selectedOrderIds.length > 0 ? false : true} onClick={onOrderReady} type="submit" className="btn btn-primary " style={{ alignSelf: 'center' }}>Ready for pick-up</button>
          )}

          {(orderDetail?.currentShipmentStatus == "In-transit") && (

            orderDetail?.LRFilePath?.length > 0 ? (
              <button onClick={onDeliveredHandler} type="submit" className="btn btn-primary " style={{ alignSelf: 'center' }}>Marks as Delivered</button>
            ) : (
              <button onClick={onTransitOrder} type="submit" className="btn btn-primary " style={{ alignSelf: 'center' }}>In transit</button>
            )


          )}





        </div>
        <Modal
          isOpen={orderQuotationOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >

          <div className="warehouseCardsec" style={{ padding: "20px" }}>

            <button className="modalCloseBtn" onClick={closeModal}>

            </button>
            <h4 className="pleaseSelectStatus">Order Summary</h4>
            <div className="row mt-3">
              <div className="col-sm-12">
                <ul className="cardlisting">
                  {
                    filteredItems.map((item, index) => {


                      return (
                        <li>
                          <div className="mt-2 d-flex justify-content-between align-items-center">

                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`pick-${item.orderDetailId}`}
                                checked={"picked"}
                                onChange={() => toggleSelect(item.orderDetailId)}
                                disabled={true}
                              />
                              <label className="form-check-label" htmlFor={`pick-${item.orderDetailId}`}>

                                <div><b>{item?.item}</b> ({item?.brand})</div>

                              </label>
                            </div>
                            <div>{`Qty - ${item?.quantity}`}</div>

                          </div>
                        </li>
                      )
                    })
                  }

                </ul>
              </div>

              <div className="mb-3 d-flex justify-content-center gap-3 mt-3">

                <button onClick={onConfirmOrder} type="submit" className="btn btn-success " style={{ alignSelf: 'center', padding: "10px 20px", fontWeight: "600" }}>
                {statusLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Uploading…
        </>
      ) : (
        "Submit"
      )}
                  </button>
                <button onClick={closeModal} type="submit" className="btn btn-danger " style={{ padding: "10px 20px", fontWeight: "500" }}>Cancel</button>
              </div>
            </div>
          </div>
        </Modal>


        <Modal
          isOpen={modalPreview}
          onRequestClose={closeModal}
          style={customStylesDisbursement}
          contentLabel="Example Modal"
        >
          <button className="modalCloseBtn" onClick={closeModal} style={closeButtonStyle}>
            <FaRegTimesCircle />
          </button>

          <div className="dataImageViewAction">
            {/* <form onSubmit={onSubmitDocument}> */}



            <div className="col-md-11">
              <div className="mb-2">
                <label htmlFor={`checkDocument_`} className="form-label">
                  {'LR Copy'}
                </label>
                <input
                  type="file"
                  accept=".pdf, .jpg, .jpeg, .png"
                  onChange={(e) => handleLrFileChange(e)}
                  name={`checkDocument_`}
                  className="form-control"
                  id={`checkDocument_`}
                />
              </div>
            </div>

            <div className="col-md-11">
              <div className="mb-2">
                <label htmlFor={`checkDocument_`} className="form-label">
                  {'Shipment Photo'}
                </label>
                <input
                  type="file"
                  accept=".pdf, .jpg, .jpeg, .png"
                  onChange={(e) => handleShipmentFileChange(e)}
                  name={`checkDocument_`}
                  className="form-control"
                  id={`checkDocument_`}
                />
              </div>
            </div>

            <div className="col-md-11">
              <div className="mb-2">
                <label htmlFor={`checkDocument_`} className="form-label">
                  {'Receipt'}
                </label>
                <input
                  type="file"
                  accept=".pdf, .jpg, .jpeg, .png"
                  onChange={(e) => handleRecieptFileChange(e)}
                  name={`checkDocument_`}
                  className="form-control"
                  id={`checkDocument_`}
                />
              </div>
            </div>


            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={markDelivered}
                id={`flexCheckDefault`}
                checked={markDelivered}
                onChange={() => setMarkDelivered(!markDelivered)}
              />
              <label className="form-check-label" htmlFor={`flexCheckDefault`}>
                {'marks as Delivered'}
              </label>
            </div>

            <div className="text-center mt-4">
              <button type="submit" className="btn btn-success" onClick={onSubmitDocument} >
                {uploadLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Uploading…
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
            {/* </form> */}
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default WarehouseOrderDetail;





